import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

/** File number of the case the form belongs to; opens the case in its module (new tab, like dashboard tasks). */
const FileCaseLink = ({ module, fileCaseId, fileNo, iconOnly }) => {
    if (!fileCaseId) return null;

    return (
        <Link
            className={iconOnly ? "file-case-link file-case-link--icon" : "file-case-link"}
            to={{ pathname: `/${module}`, search: `?fileCaseId=${fileCaseId}` }}
            target="_blank"
            title={`Open case ${fileNo || ""}`.trim()}
            aria-label={`Open case ${fileNo || ""}`.trim()}
            // Rows in the forms list are clickable too
            onClick={(e) => e.stopPropagation()}
        >
            {iconOnly ? <ExternalLink size={16} /> : fileNo}
        </Link>
    );
};

FileCaseLink.propTypes = {
    module: PropTypes.string,
    fileCaseId: PropTypes.number,
    fileNo: PropTypes.string,
    iconOnly: PropTypes.bool,
};

FileCaseLink.defaultProps = {
    module: undefined,
    fileCaseId: undefined,
    fileNo: undefined,
    iconOnly: false,
};

export default FileCaseLink;
